<section
  class="financial-institution-register"
  *appHasPermission="financialInstitutionPermissions.MODULE">
  <div class="financial-institution-register__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
  </div>
  <div class="financial-institution-register__header">
    <div class="financial-institution-register__header__title">
      <div class="financial-institution-register__header__title__icon" (click)="cancelRegister()">
        <i class="pi pi-arrow-left"></i>
      </div>
      <h1>{{ tk.Management.FinancialInstitutions | t }}</h1>
    </div>
    <div class="financial-institution-register__header__actions">
      <div class="financial-institution-register__header__actions__button">
        <app-button
          [id]="'cancel-register'"
          [label]="tk.User.Cancel | t"
          [type]="'button'"
          [theme]="'white'"
          (sendButtonClick)="cancelRegister()"></app-button>
      </div>
      <div
        class="financial-institution-register__header__actions__button"
        *appHasPermission="financialInstitutionPermissions.CREATE">
        <app-button
          [id]="'register-group'"
          [label]="tk.User.Finish | t"
          [type]="'button'"
          [disabled]="financialInstitutionForm.invalid"
          (sendButtonClick)="registerFinancialInstitution()"></app-button>
      </div>
    </div>
  </div>
  <div class="financial-institution-register__content">
    <form
      *ngIf="financialInstitutionForm"
      [formGroup]="financialInstitutionForm"
      appAutoFormGroup
      class="financial-institution-register-form">
      <!-- First Row: Identification Data Card (Full Width) -->
      <app-form-card
        icon="pi pi-id-card"
        title="Dados de Identificação"
        description="Informações principais para identificação da instituição financeira"
        customClass="identification-card"
        contentLayout="flex">
        <div class="fields-grid">
          <div class="field-container">
            <app-input
              [type]="'text'"
              [placeholder]="'Nome da instituição financeira'"
              [controlName]="financialInstitutionRegisterProps.institutionName"
              [label]="tk.Management.Name | t"
              [tooltipText]="
                'Informe o nome completo da instituição financeira conforme registro oficial.'
              "
              [required]="true"></app-input>
          </div>
          <div class="field-container">
            <app-input
              [type]="'text'"
              [placeholder]="'000'"
              [controlName]="financialInstitutionRegisterProps.compensationCode"
              [label]="tk.Management.CompensationCode | t"
              [tooltipText]="
                'Código de compensação bancária de 3 dígitos usado para identificação da instituição no sistema bancário brasileiro.'
              "
              [required]="true"></app-input>
          </div>
          <div class="field-container">
            <app-input
              [type]="'text'"
              [placeholder]="'00000000'"
              [controlName]="financialInstitutionRegisterProps.ispb"
              [label]="tk.Management.Ispb | t"
              [tooltipText]="
                'Identificador do Sistema de Pagamentos Brasileiro (ISPB) de 8 dígitos usado para identificação única da instituição no sistema financeiro.'
              "
              [required]="true"></app-input>
          </div>
          <div class="field-container">
            <app-input
              [type]="'useMask'"
              [unmask]="true"
              mask="99.999.999/9999-99"
              [placeholder]="'00.000.000/0000-00'"
              [controlName]="financialInstitutionRegisterProps.cnpj"
              label="CNPJ"
              [tooltipText]="
                'Cadastro Nacional da Pessoa Jurídica da instituição financeira. O CNPJ será armazenado apenas com números.'
              "
              [required]="true"></app-input>
          </div>
        </div>
      </app-form-card>

      <!-- Second Row: Display Information Card -->
      <app-form-card
        icon="pi pi-eye"
        title="Informações de Exibição"
        description="Dados utilizados para exibição e apresentação da instituição">
        <div class="fields-grid">
          <div class="field-container">
            <app-input
              [type]="'text'"
              [placeholder]="'Nome curto'"
              [controlName]="financialInstitutionRegisterProps.shortName"
              [label]="tk.Management.ShortName | t"
              [tooltipText]="
                'Nome abreviado ou sigla da instituição financeira usado em espaços com limitação de caracteres.'
              "
              [required]="true"></app-input>
          </div>
          <div class="field-container">
            <app-input
              [type]="'text'"
              [placeholder]="'Nome de exibição'"
              [controlName]="financialInstitutionRegisterProps.displayName"
              [label]="tk.Management.DisplayName | t"
              [tooltipText]="
                'Nome que será exibido nas interfaces do sistema. Geralmente é uma versão mais amigável do nome oficial.'
              "
              [required]="true"></app-input>
          </div>
        </div>
      </app-form-card>

      <!-- Third Row: Additional Information Card -->
      <app-form-card
        icon="pi pi-globe"
        title="Informações Complementares"
        description="Dados adicionais sobre a instituição financeira">
        <div class="fields-grid">
          <div class="field-container">
            <app-input
              [type]="'text'"
              [placeholder]="'Rede bancária'"
              [controlName]="financialInstitutionRegisterProps.network"
              [label]="tk.Management.Network | t"
              [tooltipText]="
                'Rede bancária à qual a instituição pertence (ex: Banco do Brasil, Bradesco, Itaú, etc.).'
              "
              [required]="true"></app-input>
          </div>
          <div class="field-container">
            <app-input
              [type]="'text'"
              [placeholder]="'https://www.exemplo.com.br'"
              [controlName]="financialInstitutionRegisterProps.url"
              [label]="tk.Management.Url | t"
              [tooltipText]="'URL do site oficial da instituição financeira.'"
              [required]="true"></app-input>
          </div>
        </div>
      </app-form-card>

      <!-- Form Actions Footer -->
      <div class="form-actions-footer">
        <div class="form-actions-footer__buttons">
          <app-button
            [id]="'cancel-register-footer'"
            [label]="tk.User.Cancel | t"
            [type]="'button'"
            [theme]="'white'"
            (sendButtonClick)="cancelRegister()"></app-button>
          <app-button
            *appHasPermission="financialInstitutionPermissions.CREATE"
            [id]="'register-group-footer'"
            [label]="tk.User.Finish | t"
            [type]="'button'"
            [disabled]="financialInstitutionForm.invalid"
            (sendButtonClick)="registerFinancialInstitution()"></app-button>
        </div>
      </div>
    </form>
  </div>
</section>
